// extracted by mini-css-extract-plugin
var _1 = "P7uZ7I2WYc9bJpw4UF6E";
export { _1 as "contactListContent" }
